import { logException } from '@config/logging/frontend-logger'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { Component } from 'react'

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    try {
      logException({
        message: 'React runtime error',
        component: 'error-boundary',
        functionName: 'componentDidCatch',
        file: 'src/components/error-boundary.jsx',
        operation: {
          name: 'react_runtime_error',
          status: 'failed',
        },
        error,
        customProperties: {
          component_stack: errorInfo?.componentStack,
        },
      })
    } catch {
      // Telemetry failures must not break the fallback UI.
    }
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <Stack
          spacing={2}
          sx={{
            height: '100vh',
            alignItems: 'center',
            justifyContent: 'center',
            px: 3,
            textAlign: 'center',
          }}
        >
          <Typography variant="h4" sx={{ fontWeight: 600, color: '#000F2B' }}>
            Something went wrong.
          </Typography>
          <Typography sx={{ color: '#7a8896' }}>
            An unexpected error occurred. Try reloading the page to continue.
          </Typography>
          <Button
            variant="contained"
            onClick={this.handleReload}
            sx={{
              backgroundColor: '#01173c',
              '&:hover': { backgroundColor: '#000F2B' },
            }}
          >
            Reload Page
          </Button>
        </Stack>
      )
    }

    return this.props.children
  }
}
